import Vue from "vue";
import Router from "vue-router";

Vue.use(Router);

export default new Router({
  mode: "history",
  base: process.env.BASE_URL,
  routes: [
    {
      path: "/",
      name: "Home",
      component: () => import("./views/Home.vue"),
    },
    {
      path: "/personal-credit",
      name: "Personal credit",
      component: () =>
        import(/* webpackChunkName: "create" */ "./views/Personal-credit.vue"),
    },
    {
      path: "/quienes-somos",
      name: "Quienes somos",
      component: () =>
        import(/* webpackChunkName: "create" */ "./views/About.vue"),
    },
    {
      path: "/faq",
      name: "Preguntas frecuentes",
      component: () =>
        import(/* webpackChunkName: "create" */ "./views/Faq.vue"),
    },
    {
      path: "/mipyme-credit",
      name: "Mipyme credit",
      component: () =>
        import(/* webpackChunkName: "create" */ "./views/Mipyme-credit.vue"),
    },
    {
      path: "/pyme-credit",
      name: "Pyme credit",
      component: () =>
        import(/* webpackChunkName: "create" */ "./views/Pyme-credit.vue"),
    },
    {
      path: "/car-credit",
      name: "Car credit",
      component: () =>
        import(/* webpackChunkName: "create" */ "./views/Car-credit.vue"),
    },
    {
      path: "/admin-site",
      name: "Admin site",
      component: () =>
        import(/* webpackChunkName: "create" */ "./views/Admin.vue"),
    },
    {
      path: "/bolsa",
      name: "Bolsa de trabajo",
      component: () =>
        import(/* webpackChunkName: "create" */ "./views/Jobs.vue"),
    },
  ],
  scrollBehavior() {
    return { x: 0, y: 0 };
  },
});
